import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  // BrowserRouter as Router,
  Routes
} from "react-router-dom";
import About from "./screens/AboutUs";
import ContactUs from "./screens/ContactUs";

import ScrollToTop from "./component/ScrollToTop";

import Footer from "./component/Footer";
import Header from "./component/Header";
import Carrers from "./screens/Carrers";
import Home from "./screens/Home";
import DigitialUtility from "./screens/Industries/DigitalUtility";
import DigitialEnergy from "./screens/Industries/DigitialEnergy";
import ElectricityGasUtility from "./screens/Industries/ElectricityGasUtility";
import EnergyUtilities from "./screens/Industries/EnergyUtilities";
import FinancialServices from "./screens/Industries/FinancialServices";
import Healthcare from "./screens/Industries/Healthcare";
import IGaming from "./screens/Industries/IGaming";
import Insurance from "./screens/Industries/Insurance";
import Manufacturing from "./screens/Industries/Manufacturing";
import PublicSector from "./screens/Industries/PublicSector";
import Retail from "./screens/Industries/Retail";
import Analytics from "./screens/Offerings/Analytics";
import ApplicationDevelopment from "./screens/Offerings/ApplicationDevelopment";
import BigData from "./screens/Offerings/BigData";
import Devops from "./screens/Offerings/Devops";
import ITManagedServices from "./screens/Offerings/ITManagedServices";
import MobilitySolutions from "./screens/Offerings/MobilitySolutions";
import TestingServices from "./screens/Offerings/TestingServices";
import InvestmentBanking from "./screens/Industries/InvestmentBanking";
import RetailWholesale from "./screens/Industries/RetailWholesale";
import CardSolutions from "./screens/Industries/CardSolutions";
import RiskandCompliance from "./screens/Industries/RiskandCompliance";
import DigitalTransformation from "./screens/Industries/DigitalTransformation";
import DigitalHealth from "./screens/Industries/DigitalHealth/page";
import PharmacyBenefitManagement from "./screens/Industries/PharmacyBenefitManagement/page";
import Payers from "./screens/Industries/Payers/page";
import Providers from "./screens/Industries/Providers/page";
import EHRConsulting from "./screens/Industries/EHRConsulting/page";
import AdvanceHealthcareDataAnalytics from "./screens/Industries/AdvanceHealthcareDataAnalytics/page";
import HospitalInformationSystems from "./screens/Industries/HospitalInformationSystems/page";
import LifeAnnuitiesRetirement from "./screens/Industries/LifeAnnuitiesRetirement/page";
import Reinsurance from "./screens/Industries/Reinsurance/page";
import PropertyCasualty from "./screens/Industries/PropertyCasualty/page";
import DigitalRetail from "./screens/Industries/DigitalRetail/page";
import SupplyChain from "./screens/Industries/SupplyChain/page";
import ECommerce from "./screens/Industries/ECommerce/page";
import OmniChannelStrategy from "./screens/Industries/OmniChannelStrategy/page";
import CustomerExperience from "./screens/Industries/CustomerExperience/page";
import Automotive from "./screens/Industries/Automotive/page";
import Industrial from "./screens/Industries/Industrial/page";
import MiningMetal from "./screens/Industries/MiningMetal/page";
import Process from "./screens/Industries/Process/page";
import Casinoengine from "./screens/Casinoengine";
import CasinoContent from './screens/CasinoContent'
import CasinoTopHeader from "./screens/CasinoTopHeader";
import CasinoBetting from "./screens/CasinoBetting/Home";
import Sportsbook from "./screens/CasinoBetting/Sportsbook";
import Omnichannel from "./screens/CasinoBetting/Omnichannel";
import EsportsServices from "./screens/CasinoBetting/EsportsServices";

function RouteList() {
  return (
    <BrowserRouter>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route exact path="/connect" element={<ContactUs />} />
        <Route exact path="/our-story" element={<About />} />

        {/* industries folder route start */}

        <Route exact path="/industries" element={<EnergyUtilities />} />
        <Route exact path="/energy-utilities" element={<EnergyUtilities />} />
        <Route
          exact
          path="/financial-services"
          element={<FinancialServices />}
        />
        <Route exact path="/healthcare" element={<Healthcare />} />
        <Route
          exact
          path="/public-sector-services"
          element={<PublicSector />}
        />
        <Route exact path="/insurance" element={<Insurance />} />
        <Route exact path="/retail" element={<Retail />} />
        <Route exact path="/manufacturing" element={<Manufacturing />} />
        <Route exact path="/igmaing" element={<IGaming />} />

        <Route
          exact
          path="/electricityandgasservices"
          element={<ElectricityGasUtility />}
        />
        <Route exact path="/digitalenergy" element={<DigitialEnergy />} />
        <Route exact path="/digital-utility" element={<DigitialUtility />} />

        <Route exact path="/retail-wholesale-banking" element={<RetailWholesale />} />
        <Route exact path="/investment-banking-and-brokerage" element={<InvestmentBanking />} />

        <Route exact path="/cards" element={<CardSolutions />} />
        <Route exact path="/risk-and-compliance" element={<RiskandCompliance />} />
        <Route exact path="/digital-transformation" element={<DigitalTransformation />} />
        <Route exact path="/digital-health" element={<DigitalHealth />} />
        <Route exact path="/pharmacybenefitservices" element={<PharmacyBenefitManagement />} />
        <Route exact path="/healthcare-payer-services" element={<Payers />} />
        <Route exact path="/providers" element={<Providers />} />
        <Route exact path="/ehr-consulting" element={<EHRConsulting />} />
        <Route exact path="/advance-healthcare-data" element={<AdvanceHealthcareDataAnalytics />} />
        <Route exact path="/hospital-information-systems" element={<HospitalInformationSystems />} />
        <Route exact path="/life-annuities-retirement" element={<LifeAnnuitiesRetirement />} />
        <Route exact path="/reinsurance" element={<Reinsurance />} />
        <Route exact path="/propert-casualty" element={<PropertyCasualty />} />
        <Route exact path="/omni-channel-services-1" element={<DigitalRetail />} />
        <Route exact path="/supply-chain-services" element={<SupplyChain />} />
        <Route exact path="/ecommerce" element={<ECommerce />} />
        <Route exact path="/omni-channel-services" element={<OmniChannelStrategy />} />
        <Route exact path="/customerexperiencesolutions" element={<CustomerExperience />} />
        <Route exact path="/automotive" element={<Automotive />} />
        <Route exact path="/industrial" element={<Industrial />} />
        <Route exact path="/metalandmining" element={<MiningMetal />} />
        <Route exact path="/processmanufacturing" element={<Process />} />
        <Route exact path="/casino-engine" element={<CasinoTopHeader />} />
        <Route exact path="/fantasy-betting" element={<CasinoBetting />} />
        <Route exact path="/fantasy-betting/sportsbook" element={<Sportsbook />} />
        <Route exact path="/fantasy-betting/omnichannel" element={<Omnichannel />} />
        <Route exact path="/fantasy-betting/esports-services" element={<EsportsServices />} />























        {/* industries folder route  end */}

        {/* Offerings folder route start */}
        <Route exact path="/offerings" element={<Analytics />} />
        <Route exact path="/analytics" element={<Analytics />} />
        <Route
          exact
          path="/application-development"
          element={<ApplicationDevelopment />}
        />
        <Route
          exact
          path="/it-managed-services"
          element={<ITManagedServices />}
        />
        <Route exact path="/big-data" element={<BigData />} />
        <Route exact path="/devops" element={<Devops />} />
        <Route
          exact
          path="/mobility-solutions"
          element={<MobilitySolutions />}
        />
        <Route exact path="/testing" element={<TestingServices />} />
        {/* Offerings folder route end */}
        <Route exact path="/careers" element={<Carrers />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default RouteList;
